/**
 * todo
 * touch
 * stop autoplay when indicator, arrows click
 * title not update when slide position changes
 * delay slider timing
 * custom delay for slide
 */

import { __ } from '@wordpress/i18n';
import { registerBlockType } from '@wordpress/blocks';
import './style.scss';

/**
 * Internal dependencies
 */
import Edit from './edit';
import save from './save';


const blockIcon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" focusable="false">
<polygon fill="#C1272D" points="4.2,0.1 0.8,0.1 0.1,0.1 0.1,1 0.1,4.2 1.1,4.2 1.1,1.1 4.2,1.1 "/>
<polygon fill="#C1272D" points="23.9,4.2 23.9,1 23.9,0.1 22.7,0.1 19.8,0.1 19.8,1.1 22.9,1.1 22.9,4.2 "/>
<polygon fill="#C1272D" points="19.8,23.9 22.7,23.9 23.9,23.9 23.9,22.9 23.9,19.8 22.9,19.8 22.9,22.9 19.8,22.9 "/>
<polygon fill="#C1272D" points="0.1,19.8 0.1,22.9 0.1,23.9 0.8,23.9 4.2,23.9 4.2,22.9 1.1,22.9 1.1,19.8 "/>
<g>
	<path fill="#C1272D" d="M9.4,18.7H6.3v-4.1h3.1c0.4,1.2,1.1,1.8,2.1,1.8c0.7,0,1.1-0.3,1.1-0.9c0-0.3-0.1-0.6-0.4-0.8
		c-0.3-0.2-0.9-0.5-1.7-0.9c-1.1-0.5-1.9-0.9-2.5-1.3c-0.5-0.3-0.9-0.8-1.3-1.4c-0.4-0.6-0.5-1.2-0.5-1.9c0-1.3,0.4-2.3,1.2-3
		c0.8-0.7,1.8-1.1,3-1.1s2.2,0.3,3.1,1V5.3h3.1v3.1h-3.1c-0.4-1.1-1-1.7-2-1.7c-0.7,0-1,0.3-1,0.9c0,0.3,0.1,0.5,0.3,0.7
		c0.2,0.1,0.8,0.5,1.8,1c1.3,0.7,2.3,1.2,2.7,1.5c0.2,0.2,0.5,0.4,0.7,0.7c0.2,0.3,0.4,0.6,0.6,0.9c0.4,0.7,0.5,1.4,0.5,2.2
		c0,1.2-0.4,2.2-1.3,3.1c-0.9,0.9-1.9,1.3-3.2,1.3c-1.2,0-2.3-0.4-3.3-1.1L9.4,18.7L9.4,18.7z"/>
</g>
</svg>
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */
registerBlockType( 'superblockslider/slider', {
	/**
	 * @see https://make.wordpress.org/core/2020/11/18/block-api-version-2/
	 */
	apiVersion: 2,

	/**
	 * This is the display title for your block, which can be translated with `i18n` functions.
	 * The block inserter will show this name.
	 */
	title: __( 'Super slider block', 'superblockslider' ),

	/**
	 * This is a short description for your block, can be translated with `i18n` functions.
	 * It will be shown in the Block Slide in the Settings Sidebar.
	 */
	description: __(
		'Images and content slider',
		'superblockslider'
	),

	/**
	 * Blocks are grouped into categories to help users browse and discover them.
	 * The categories provided by core are `text`, `media`, `design`, `widgets`, and `embed`.
	 */
	category: 'media',

	/**
	 * An icon property should be specified to make it easier to identify a block.
	 * These can be any of WordPress’ Dashicons, or a custom svg element.
	 */
	icon: blockIcon,

	/**
	 * Optional block extended support features.
	 */
	supports: {
		// html: false,
		align: true,
	},
	// example: {
	// 	attributes: {
	// 		slides: [],
	// 	}
	// },
	attributes: {
		slides: {
			type: 'array',
			default: [],
		},
		initialActiveSlideValue: {
			type: 'integer',
			default: 0,
		},
		transitionSpeedValue: {
			type: 'string',
			default: '.6s',
		},
		transitionAnimationValue: {
			type: 'string',
			default: 'cubic-bezier(0.46, 0.03, 0.52, 0.96)',
		},
		autoplayValue: {
			type: 'boolean',
			default: true,
		},
		autoplayIntervalValue: {
			type: 'string',
			default: '1.5s',
		},
		loopSlideValue: {
			type: 'boolean',
			default: true,
		},
		slideNavigationValue: {
			type: 'string',
			default: 'dots',
		},
		hoverPauseValue: {
			type: 'boolean',
			default: true,
		},
		arrowNavigationValue: {
			type: 'boolean',
			default: true,
		},
		navigationColorValue: {
			type: 'string',
			default: '',
		},
		sliderHeightValue: {
			type: 'string',
			default: '100vh',
		},
		sliderWidthValue: {
			type: 'string',
			default: '100%',
		},
		transitionEffectValue: {
			type: 'string',
			default: 'slide',
		},
		
	},
	providesContext: {
		'superblockslider/slider/initialActiveSlideValue': 'initialActiveSlideValue',
		'superblockslider/slider/transitionEffectValue': 'transitionEffectValue',
		'superblockslider/slider/transitionSpeedValue': 'transitionSpeedValue',
		'superblockslider/slider/transitionAnimationValue': 'transitionAnimationValue',
	},

	edit: Edit,

	save,
} );
